import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../environments/environment";
import {City, ICity} from "../models/city.model";
@Injectable({
  providedIn: 'root'
})
export class CityService {

  constructor(private http: HttpClient) { }

  getCity() : Observable<City>{
    return this.http.get<City>(`${environment.url}/city`);
  }

  getAllCities() : Observable<any>{
    return this.http.get<any>(`${environment.url}/city/cities`);
  }

  getCitiesByCountry(idCountry:number) : Observable<City>{
    return this.http.get<City>(`${environment.url}/city/country/`+idCountry);
  }

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/city` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getCityBycurrentSearch(search: string, page: number, size: number){
    return this.http.get<any>(`${environment.url}/city` + ('/_search?search=name:' + search +'&page=' + page + "&size=" + size));
  }

  saveCity(City:ICity){
    return this.http.post<any>(`${environment.url}/city`,City);
  }

  getidCity(idA:number){
    return this.http.get(`${environment.url}/city/`+idA);
  }

  updateCity(City:ICity){
    return this.http.put<any>(`${environment.url}/city/`+City.id,City);
  }

  deleteCity(idA:number){
    return this.http.delete(`${environment.url}/city/`+idA);
  }
}
